import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { MessageDescriptor } from 'react-intl';
import { AdminSidebarLink } from './AdminSidebarLink';

export interface SidebarItem {
  to: string;
  message?: MessageDescriptor;
  label?: string;
  icon: ReactNode;
  isActive?: (pathname: string) => boolean;
}

interface AdminSidebarGroupProps {
  title: string;
  items: SidebarItem[];
  /** First group sits flush with the top of the column. */
  flushTop?: boolean;
}

/** Wayfinding label for a group of icon links. Quieter than a panel title. */
export function AdminSidebarGroup({ title, items, flushTop = false }: AdminSidebarGroupProps) {
  return (
    <Box>
      <Typography
        variant="caption"
        color="text.secondary"
        component="div"
        sx={{ pt: flushTop ? 0.5 : 2, pb: 0.5 }}
      >
        {title}
      </Typography>
      {items.map((item) => (
        <AdminSidebarLink
          key={item.to}
          to={item.to}
          message={item.message}
          label={item.label}
          icon={item.icon}
          isActive={item.isActive}
        />
      ))}
    </Box>
  );
}
